import { LocalStorageKey } from "@/common/constants/localStorage";
import { BaseEntityDto } from "@/core/api/generated/v1";

import { LocalStorageHelper } from "../storage/localStorage";
import { RepairSparePartAutocompleteSettings } from "./repairSparePart";
import { RepairSpecAutocompleteSettings } from "./repairSpec";

/** Repair spec, material, work, etc/ */
export type RepairEntityDtoType = BaseEntityDto & { tenantId?: Nil<string> };

export interface RepairEntitySettingsInLocalStorage {
  /** Tenant to be selected by default when accessing cross-tenant repair entities. */
  defaultTenantIdForCrossTenant?: Nil<string>;

  /** Autocomplete filter settings for repair spare parts. */
  repairSparePartAutocompleteSettings?: RepairSparePartAutocompleteSettings;

  /** Autocomplete filter settings for repair spec. */
  repairSpecAutocompleteSettings?: RepairSpecAutocompleteSettings;
}

export class RepairHelper {
  public static isExternal(params: {
    tenantId: Nil<string>;
    repairEntity: Nil<RepairEntityDtoType>;
  }): boolean {
    return (
      !!params.tenantId && !!params.repairEntity && params.tenantId !== params.repairEntity.tenantId
    );
  }

  public static getLocalSettings(): Nil<RepairEntitySettingsInLocalStorage> {
    return (
      LocalStorageHelper.getTypedJsonItem<RepairEntitySettingsInLocalStorage>(
        LocalStorageKey.repairEntitySettings,
      ) ||
      LocalStorageHelper.getTypedJsonItem<RepairEntitySettingsInLocalStorage>(
        LocalStorageKey.repairSpecSettings,
      ) // migrate from old settings
    );
  }

  public static saveLocalSettings(settings: Nil<RepairEntitySettingsInLocalStorage>): void {
    LocalStorageHelper.setJsonItem(LocalStorageKey.repairEntitySettings, settings);
  }
}
